// // src/components/ProductModal.js
// import React, { useEffect, useState } from "react";
// import { Modal, Form, Input, InputNumber, Upload, message, Button } from "antd";
// import { UploadOutlined } from "@ant-design/icons";

// // Firebase Storage
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { storage } from "../firebaseClient";

// // ✅ IMPORTANTE: garante que seu initializeApp roda antes
// // import "../firebaseClient"; // ou import { storage } from "../firebaseClient";

// export default function ProductModal({
//   open,
//   editing,
//   onCancel,
//   onCreate,
//   onUpdate,
// }) {
//   const [form] = Form.useForm();

//   const [bulkMode, setBulkMode] = useState(false);

//   // arquivo escolhido
//   const [file, setFile] = useState(null);

//   // controla o Upload do AntD (pra não sumir / não resetar estranho)
//   const [fileList, setFileList] = useState([]);

//   useEffect(() => {
//     if (!open) return;

//     form.setFieldsValue({
//       productName: editing?.productName || "",
//       productUrl: editing?.productUrl || "",
//       priceFrom: editing?.priceFrom ?? null,
//       priceTo: editing?.priceTo ?? null,
//       couponName: editing?.couponName || "",
//       couponValue: editing?.couponValue ?? null,
//     });

//     // ✅ Se estiver editando e já tiver imagem salva, mostra preview
//     if (editing?.imageUrl) {
//       setFile(null);
//       setFileList([
//         {
//           uid: "-1",
//           name: "imagem-atual.jpg",
//           status: "done",
//           url: editing.imageUrl,
//         },
//       ]);
//     } else {
//       setFile(null);
//       setFileList([]);
//     }
//   }, [open, editing, form]);

//   async function uploadToStorage(f) {
//     // ✅ validações rápidas
//     if (!f) throw new Error("Arquivo não encontrado");
//     if (!f.type?.startsWith("image/")) {
//       const err = new Error("Arquivo precisa ser imagem");
//       err.code = "invalid-file-type";
//       throw err;
//     }

//     const ext = (f.name?.split(".").pop() || "jpg").toLowerCase();
//     const fileName = `${Date.now()}-${Math.random().toString(16).slice(2)}.${ext}`;
//     const storagePath = `queue_images/${fileName}`;

//     // ✅ debug útil (só pra você confirmar)
//     // console.log("Storage bucket:", storage.app.options.storageBucket);

//     const storageRef = ref(storage, storagePath);
//     await uploadBytes(storageRef, f);
//     const url = await getDownloadURL(storageRef);

//     return { url, path: storagePath };
//   }

//   const handleOk = async () => {
//     const values = await form.validateFields();

//     const payload = {
//       productName: values.productName,
//       productUrl: values.productUrl,
//       priceFrom: values.priceFrom ?? null,
//       priceTo: values.priceTo ?? null,
//       couponName: values.couponName || "",
//       couponValue: values.couponValue ?? null,
//     };
//     try {
//       // ✅ Se selecionou NOVA imagem: sobe e salva
//       if (file) {
//         message.loading({ content: "Enviando imagem...", key: "upload" });

//         const { url, path } = await uploadToStorage(file);

//         payload.imageUrl = url;
//         payload.imagePath = path;

//         message.success({ content: "Imagem enviada ✅", key: "upload" });
//       } else {
//         // ✅ Se está editando e não selecionou nova imagem: mantém a antiga
//         if (editing?.imageUrl) {
//           payload.imageUrl = editing.imageUrl;
//           payload.imagePath = editing.imagePath || null;
//         }
//       }
//       console.log("PAYLOAD ENVIADO:", payload);
//       if (editing) return onUpdate(payload);
//       return onCreate(payload);
//     } catch (err) {
//       console.error("UPLOAD ERROR:", err);
//       message.error(`Erro ao enviar imagem: ${err?.code || err?.message || "desconhecido"}`);
//     }
//   };

//   return (
//     <Modal
//       open={open}
//       title={editing ? "Editar item" : "Adicionar item"}
//       onCancel={onCancel}
//       onOk={handleOk}
//       okText={editing ? "Salvar" : "Adicionar"}
//       cancelText="Cancelar"
//       destroyOnClose
//     >
//       <Button onClick={() => setBulkMode(!bulkMode)}>
//         {bulkMode ? "Cadastro individual" : "Divulgar em massa"}
//       </Button>
//       <Form form={form} layout="vertical">
//         <Form.Item
//           name="productName"
//           label="Nome do produto"
//           rules={[{ required: true, message: "Digite o nome" }]}
//         >
//           <Input placeholder="Ex: Camiseta Oversized Drop III" />
//         </Form.Item>

//         <Form.Item
//           name="productUrl"
//           label="Link do produto"
//           rules={[
//             { required: true, message: "Cole o link" },
//             { type: "url", message: "URL inválida" },
//           ]}
//         >
//           <Input placeholder="https://..." />
//         </Form.Item>

//         <div style={{ display: "flex", gap: 12 }}>
//           <Form.Item
//             style={{ flex: 1 }}
//             name="priceFrom"
//             label="Preço de (R$)"
//             rules={[{ required: true, message: "Informe o preço de" }]}
//           >
//             <InputNumber
//               style={{ width: "100%" }}
//               min={0}
//               precision={2}
//               decimalSeparator=","
//               placeholder="Ex: 199,90"
//             />
//           </Form.Item>

//           <Form.Item
//             style={{ flex: 1 }}
//             name="priceTo"
//             label="Preço por (R$) – opcional"
//           >
//             <InputNumber
//               style={{ width: "100%" }}
//               min={0}
//               precision={2}
//               decimalSeparator=","
//               placeholder="Ex: 149,90"
//             />
//           </Form.Item>
//         </div>

//         <div>
//           <div style={{ display: "flex", gap: 12 }}>
//             <Form.Item
//               style={{ flex: 1 }}
//               name="couponName"
//               label="Nome do cupom"
//             >
//               <Input placeholder="Ex: PRIMEIRA10" />
//             </Form.Item>

//             <Form.Item
//               style={{ flex: 1 }}
//               name="couponValue"
//               label="Valor do cupom (%)"
//             >
//               <InputNumber
//                 style={{ width: "100%" }}
//                 min={0}
//                 max={100}
//                 formatter={(value) => `${value}%`}
//                 parser={(value) => value.replace("%", "")}
//                 placeholder="Ex: 10%"
//               />
//             </Form.Item>
//           </div>
//         </div>

//         {/* ✅ Upload da imagem */}
//         <Form.Item label="Imagem do produto (opcional)">
//           <Upload
//             accept="image/*"
//             listType="picture"
//             maxCount={1}
//             fileList={fileList}
//             beforeUpload={() => false} // não faz upload automático
//             onChange={({ fileList: newList }) => {
//               setFileList(newList);

//               // se escolheu um arquivo novo, pega o originFileObj
//               const f = newList?.[0]?.originFileObj || null;
//               setFile(f);
//             }}
//             onRemove={() => {
//               setFile(null);
//               setFileList([]);
//             }}
//           >
//             <button type="button" className="ant-btn">
//               <UploadOutlined /> Selecionar imagem
//             </button>
//           </Upload>

//           <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
//             Dica: imagem quadrada (1080x1080) fica perfeita no WhatsApp.
//           </div>
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// }


// src/components/ProductModal.js
import React, { useEffect, useState } from "react";
import { Modal, Form, Input, InputNumber, Upload, message, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

// Firebase Storage
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseClient";

export default function ProductModal({
  open,
  editing,
  onCancel,
  onCreate,
  onUpdate,
}) {
  const [form] = Form.useForm();

  const [bulkMode, setBulkMode] = useState(false);

  // arquivo escolhido no modo individual
  const [file, setFile] = useState(null);

  // controla o Upload individual
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (!open) return;

    // Se estiver editando, força modo individual
    if (editing) {
      setBulkMode(false);
    }

    form.setFieldsValue({
      productName: editing?.productName || "",
      description: editing?.description || "",
      productUrl: editing?.productUrl || "",
      priceFrom: editing?.priceFrom ?? null,
      priceTo: editing?.priceTo ?? null,
      couponName: editing?.couponName || "",
      couponValue: editing?.couponValue ?? null,
      products: [
        {
          productName: "",
          description: "",
          productUrl: "",
          priceFrom: null,
          priceTo: null,
          couponName: "",
          couponValue: null,
          imageFile: [],
        },
      ],
    });

    if (editing?.imageUrl) {
      setFile(null);
      setFileList([
        {
          uid: "-1",
          name: "imagem-atual.jpg",
          status: "done",
          url: editing.imageUrl,
        },
      ]);
    } else {
      setFile(null);
      setFileList([]);
    }
  }, [open, editing, form]);

  async function uploadToStorage(f) {
    if (!f) throw new Error("Arquivo não encontrado");

    if (!f.type?.startsWith("image/")) {
      const err = new Error("Arquivo precisa ser imagem");
      err.code = "invalid-file-type";
      throw err;
    }

    const ext = (f.name?.split(".").pop() || "jpg").toLowerCase();
    const fileName = `${Date.now()}-${Math.random()
      .toString(16)
      .slice(2)}.${ext}`;

    const storagePath = `queue_images/${fileName}`;
    const storageRef = ref(storage, storagePath);

    await uploadBytes(storageRef, f);

    const url = await getDownloadURL(storageRef);

    return { url, path: storagePath };
  }

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      // =========================
      // ✅ MODO DIVULGAR EM MASSA
      // =========================
      if (bulkMode && !editing) {
        const products = values.products || [];

        if (!products.length) {
          message.warning("Adicione pelo menos 1 produto.");
          return;
        }

        message.loading({
          content: "Cadastrando carrossel...",
          key: "bulk-create",
        });

        const productsPayload = [];

        for (const product of products) {
          const payload = {
            productName: product.productName,
            description: product.description || "",
            productUrl: product.productUrl,
            priceFrom: product.priceFrom ?? null,
            priceTo: product.priceTo ?? null,
            couponName: product.couponName || "",
            couponValue: product.couponValue ?? null,
          };

          const f = product.imageFile?.[0]?.originFileObj || null;

          if (f) {
            const { url, path } = await uploadToStorage(f);
            payload.imageUrl = url;
            payload.imagePath = path;
          }

          productsPayload.push(payload);
        }

        await onCreate({
          type: "carousel",
          products: productsPayload,
        });

        message.success({
          content: "Carrossel cadastrado com sucesso ✅",
          key: "bulk-create",
        });

        form.resetFields();
        setBulkMode(false);

        return;
      }

      // =========================
      // ✅ MODO INDIVIDUAL
      // =========================
      const payload = {
        productName: values.productName,
        description: values.description || "",
        productUrl: values.productUrl,
        priceFrom: values.priceFrom ?? null,
        priceTo: values.priceTo ?? null,
        couponName: values.couponName || "",
        couponValue: values.couponValue ?? null,
      };

      if (file) {
        message.loading({ content: "Enviando imagem...", key: "upload" });

        const { url, path } = await uploadToStorage(file);

        payload.imageUrl = url;
        payload.imagePath = path;

        message.success({ content: "Imagem enviada ✅", key: "upload" });
      } else {
        if (editing?.imageUrl) {
          payload.imageUrl = editing.imageUrl;
          payload.imagePath = editing.imagePath || null;
        }
      }

      console.log("PAYLOAD ENVIADO:", payload);

      if (editing) return onUpdate(payload);

      return onCreate(payload);
    } catch (err) {
      console.error("PRODUCT MODAL ERROR:", err);
      message.error(
        `Erro ao salvar: ${err?.code || err?.message || "desconhecido"}`
      );
    }
  };

  return (
    <Modal
      open={open}
      title={
        editing
          ? "Editar item"
          : bulkMode
            ? "Divulgar em massa"
            : "Adicionar item"
      }
      onCancel={onCancel}
      onOk={handleOk}
      okText={editing ? "Salvar" : bulkMode ? "Cadastrar produtos" : "Adicionar"}
      cancelText="Cancelar"
      destroyOnClose
      width={bulkMode ? 820 : 520}
    >
      {!editing && (
        <div style={{ marginBottom: 16 }}>
          <Button onClick={() => setBulkMode(!bulkMode)}>
            {bulkMode ? "Cadastro individual" : "Divulgar em massa"}
          </Button>
        </div>
      )}

      <Form form={form} layout="vertical">
        {!bulkMode ? (
          <>
            <Form.Item
              name="productName"
              label="Nome do produto"
              rules={[{ required: true, message: "Digite o nome" }]}
            >
              <Input placeholder="Ex: Camiseta Oversized Drop III" />
            </Form.Item>

            <Form.Item
              name="description"
              label="Informações complementares (opcional)"
              extra="Texto livre: detalhes, tamanhos, frete, condições, o que quiser."
            >
              <Input.TextArea
                rows={4}
                maxLength={1200}
                showCount
                placeholder={
                  "Ex: Frete grátis para todo o Brasil\n" +
                  "Disponível do P ao GG\n" +
                  "Últimas unidades!"
                }
              />
            </Form.Item>

            <Form.Item
              name="productUrl"
              label="Link do produto"
              rules={[
                { required: true, message: "Cole o link" },
                { type: "url", message: "URL inválida" },
              ]}
            >
              <Input placeholder="https://..." />
            </Form.Item>

            <div style={{ display: "flex", gap: 12 }}>
              <Form.Item
                style={{ flex: 1 }}
                name="priceFrom"
                label="Preço de (R$)"
                rules={[{ required: true, message: "Informe o preço de" }]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  precision={2}
                  decimalSeparator=","
                  placeholder="Ex: 199,90"
                />
              </Form.Item>

              <Form.Item
                style={{ flex: 1 }}
                name="priceTo"
                label="Preço por (R$) – opcional"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  precision={2}
                  decimalSeparator=","
                  placeholder="Ex: 149,90"
                />
              </Form.Item>
            </div>

            <div style={{ display: "flex", gap: 12 }}>
              <Form.Item
                style={{ flex: 1 }}
                name="couponName"
                label="Nome do cupom"
              >
                <Input placeholder="Ex: PRIMEIRA10" />
              </Form.Item>

              <Form.Item
                style={{ flex: 1 }}
                name="couponValue"
                label="Valor do cupom (%)"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={100}
                  formatter={(value) => `${value}%`}
                  parser={(value) => value.replace("%", "")}
                  placeholder="Ex: 10%"
                />
              </Form.Item>
            </div>

            <Form.Item label="Imagem do produto (opcional)">
              <Upload
                accept="image/*"
                listType="picture"
                maxCount={1}
                fileList={fileList}
                beforeUpload={() => false}
                onChange={({ fileList: newList }) => {
                  setFileList(newList);

                  const f = newList?.[0]?.originFileObj || null;
                  setFile(f);
                }}
                onRemove={() => {
                  setFile(null);
                  setFileList([]);
                }}
              >
                <button type="button" className="ant-btn">
                  <UploadOutlined /> Selecionar imagem
                </button>
              </Upload>

              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
                Dica: imagem quadrada (1080x1080) fica perfeita no WhatsApp.
              </div>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.List name="products">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }, index) => (
                    <div
                      key={key}
                      style={{
                        border: "1px solid rgba(0,0,0,.12)",
                        padding: 16,
                        borderRadius: 12,
                        marginBottom: 16,
                        background: "rgba(0,0,0,.02)",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 700,
                          marginBottom: 12,
                          fontSize: 15,
                        }}
                      >
                        Produto {index + 1}
                      </div>

                      <Form.Item
                        name={[name, "productName"]}
                        label="Nome do produto"
                        rules={[{ required: true, message: "Digite o nome" }]}
                      >
                        <Input placeholder="Ex: Camiseta Oversized Drop III" />
                      </Form.Item>

                      <Form.Item
                        name={[name, "description"]}
                        label="Informações complementares (opcional)"
                        extra="Texto livre: detalhes, tamanhos, frete, condições, o que quiser."
                      >
                        <Input.TextArea
                          rows={3}
                          maxLength={1200}
                          showCount
                          placeholder={
                            "Ex: Frete grátis para todo o Brasil\n" +
                            "Últimas unidades!"
                          }
                        />
                      </Form.Item>

                      <Form.Item
                        name={[name, "productUrl"]}
                        label="Link do produto"
                        rules={[
                          { required: true, message: "Cole o link" },
                          { type: "url", message: "URL inválida" },
                        ]}
                      >
                        <Input placeholder="https://..." />
                      </Form.Item>

                      <div style={{ display: "flex", gap: 12 }}>
                        <Form.Item
                          style={{ flex: 1 }}
                          name={[name, "priceFrom"]}
                          label="Preço de (R$)"
                          rules={[
                            { required: true, message: "Informe o preço de" },
                          ]}
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            precision={2}
                            decimalSeparator=","
                            placeholder="Ex: 199,90"
                          />
                        </Form.Item>

                        <Form.Item
                          style={{ flex: 1 }}
                          name={[name, "priceTo"]}
                          label="Preço por (R$) – opcional"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            precision={2}
                            decimalSeparator=","
                            placeholder="Ex: 149,90"
                          />
                        </Form.Item>
                      </div>

                      <div style={{ display: "flex", gap: 12 }}>
                        <Form.Item
                          style={{ flex: 1 }}
                          name={[name, "couponName"]}
                          label="Nome do cupom"
                        >
                          <Input placeholder="Ex: PRIMEIRA10" />
                        </Form.Item>

                        <Form.Item
                          style={{ flex: 1 }}
                          name={[name, "couponValue"]}
                          label="Valor do cupom (%)"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            max={100}
                            formatter={(value) => `${value}%`}
                            parser={(value) => value.replace("%", "")}
                            placeholder="Ex: 10%"
                          />
                        </Form.Item>
                      </div>

                      <Form.Item
                        name={[name, "imageFile"]}
                        label="Imagem do produto (opcional)"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e?.fileList || []}
                      >
                        <Upload
                          accept="image/*"
                          listType="picture"
                          maxCount={1}
                          beforeUpload={() => false}
                        >
                          <button type="button" className="ant-btn">
                            <UploadOutlined /> Selecionar imagem
                          </button>
                        </Upload>
                      </Form.Item>

                      {fields.length > 1 && (
                        <Button danger onClick={() => remove(name)}>
                          Remover produto
                        </Button>
                      )}
                    </div>
                  ))}

                  {fields.length < 10 && (
                    <Button
                      type="dashed"
                      block
                      onClick={() =>
                        add({
                          productName: "",
                          description: "",
                          productUrl: "",
                          priceFrom: null,
                          priceTo: null,
                          couponName: "",
                          couponValue: null,
                          imageFile: [],
                        })
                      }
                    >
                      + Adicionar produto
                    </Button>
                  )}

                  {fields.length >= 10 && (
                    <div style={{ fontSize: 12, opacity: 0.7, marginTop: 8 }}>
                      Limite máximo de 10 produtos por cadastro em massa.
                    </div>
                  )}
                </>
              )}
            </Form.List>
          </>
        )}
      </Form>
    </Modal>
  );
}